export default ngModule => {
    ngModule.filter('titlecase', function () {
        return function (s) {
            s = ( s === undefined || s === null ) ? '' : s;
            return s.toString().toLowerCase().replace(/\b([a-z])/g, function (ch) {
                return ch.toUpperCase();
            });
        };
    });

    ngModule.filter('to_trusted', ['$sce', function($sce){
        return function(text) {
            return $sce.trustAsHtml(text);
        };
    }]);
};


// WEBPACK FOOTER //
// ./src/filters/text.js